function Footer() {
  return (
    <section className='footer-container' id='footer'>
      <div className='footer-texts'>
        <div>
          <p><b>J COMPA COLOMBIA SAS</b></p>
          <ul>
            <li> <a href='https://www.instagram.com/compa.colombia/' target="_blank"> Instagram </a> </li>
            <li> <a href='https://www.linkedin.com/company/compacolombia/' target="_blank"> Linkedin </a> </li>
            <li> <a href='/compa2024' target="_blank"> Linkedin </a> </li>
          </ul>
        </div>
        <div>
          <ul>
            <li> <a href='/#Title' > Home </a> </li>
            <li> <a href='#Projects' > Proyectos </a> </li>
            <li> <a href='#Services' > Servicios </a> </li>
            <li> <a href='#Contact' > Contacto </a> </li>
          </ul>
          <p><b>gestion@compa.com.co</b></p>
        </div>
      </div>
    </section>
  );
}

export default Footer;
